export var ResizeMode;

(function (ResizeMode) {
  ResizeMode["CONTAIN"] = "contain";
  ResizeMode["COVER"] = "cover";
  ResizeMode["STRETCH"] = "stretch";
})(ResizeMode || (ResizeMode = {}));